import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

const ControlsView = ({ tableInstance }) => {
  const { selectedFlatRows, setIsOpen, onOpenViewModal } = tableInstance;
  const viewButtonClick = () => {
    // toggleAllPageRowsSelected(false);
    // setIsOpenAddEditDeleteModal(true);

    onOpenViewModal();
  };

  if (selectedFlatRows.length !== 1) {
    return (
      <Button
        variant="foreground-alternate"
        className="btn-icon btn-icon-only shadow view-datatable"
        disabled
      >
        <CsLineIcons icon="eye" />
      </Button>
    );
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top-view">View</Tooltip>}>
      <Button
        onClick={viewButtonClick}
        variant="foreground-alternate"
        className="btn-icon btn-icon-only shadow view-datatable"
      >
        <CsLineIcons icon="eye" />
      </Button>
    </OverlayTrigger>
  );
};
export default ControlsView;
